import React, { Component } from 'react';
import './footer.css';
import logomark from '../assets/logomark.svg';
import logotype from '../assets/logo-still-light.gif';
import iconInstagram from '../assets/instagram-light.gif';
import iconTikTok from '../assets/tiktok-light.gif';


export default class Footer extends Component {
  static propTypes = {};

  render() {
    return (
      <footer>
        <div className="footer-container">
            <div className="grid">
                <div>
                  <img id="logomark" alt="logo" src={logomark} />
                  <img id="logotype" alt="logo" src={logotype} />
                </div>
                <div className="lists">
                    <div className="list">

                        <span>Get in Touch</span>
                        <ul>
                            <li><a href="mailTo:michael@skwiz.co">Contact</a></li>
                            <li><a href="./press">Press</a></li>
                            <li><a href="./events">Events</a></li>
                        </ul>
                    </div>
                    <div className="list">
                        <span>Let's Play</span>
                        <ul>
                            <li>
                                <a href="https://apps.apple.com/us/app/skwiz/id1611258643?platform=iphone" target="_blank" rel="noreferrer">iPhone</a>
                            </li>
                            <li>
                                <a href="https://apps.apple.com/us/app/skwiz/id1611258643?platform=ipad" target="_blank" rel="noreferrer">iPad</a>
                            </li>
                            <li>
                                <a href="https://apps.apple.com/us/app/skwiz/id1611258643?platform=mac" target="_blank" rel="noreferrer">Mac</a>
                            </li>
                            <li>
                                <a href="https://apps.apple.com/us/app/skwiz/id1611258643?platform=messages" target="_blank" rel="noreferrer">iMessage</a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>

        <div id="subfooter" className="footer-container">
            <div className="grid">
                <div id="social-links">
                    <a className="icon-link" href="https://www.instagram.com/skwizcorpse/" target="_blank" rel="noreferrer"><img className="icon" alt="Instagram" src={iconInstagram} /></a>
                    <a className="icon-link" href="https://www.tiktok.com/@skwizcorpse" target="_blank" rel="noreferrer"><img className="icon" alt="Tik Tok" src={iconTikTok} /></a>
                </div>
                <div id="privacy-links">
                  <a href="./privacy">Privacy</a>
                  <a href="./terms">Terms</a>
                  <a href="https://jerks.ink/" target="_blank" rel="noreferrer"><span className="copyright">© <script>document.write(new Date().getFullYear())</script> jERKS iNC.</span></a>
              </div>
            </div>
        </div>

      </footer>
    );
  }
}
